/* Nuvō favorites, on every page (snippets/nuvo-cart.liquid). Styles: assets/nuvo-cart.css.
   - A heart on each product card on collection pages, and on the home page cards (sections/nuvo-home-shop.liquid,
     whose cards carry the heart in their markup and data-nf-card).
   - A heart on the product page, beside the title (snippets/nuvo-pdp-actions.liquid).
   - A heart button in the header, beside the cart, with the count; it opens a dark panel listing the saved pieces.
   - Compare: pick two to four favorites and see them side by side (category, price, material, sizes, ignition,
     finishes, gas), read from each product's own data.
   Favorites live in this browser (localStorage), each with what the panel needs to show it. Each new favorite is
   published to Shopify's customer-events bus as "nuvo_favorite_added"; a custom pixel in Settings → Customer events
   can forward it to Meta as AddToWishlist to measure the most-favorited pieces. */
(() => {
  const KEY = 'nuvo-favs';
  const read = () => {
    try { return (JSON.parse(localStorage.getItem(KEY)) || []).filter((f) => f && typeof f === 'object' && f.id); } catch (err) { return []; }
  };
  const write = (list) => { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (err) {} };
  const has = (id) => read().some((f) => f.id === String(id));
  const esc = (s) => String(s || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  const HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.4-7.5-10.1A4.4 4.4 0 0 1 12 7.6a4.4 4.4 0 0 1 7.5 2.8c0 5.7-7.5 10.1-7.5 10.1Z"/></svg>';
  const ARCH = '<svg class="nfv-empty__arch" viewBox="40 40 1296 1920" aria-hidden="true"><path fill="#B8945C" d="M61 1937V684A627 628 0 0 1 1315 684V1937L1094 1716V684A405.5 355 0 0 0 283 684V1716Z"/><path fill="none" stroke="#F6F3EE" stroke-width="58" stroke-linejoin="round" d="M688 1687H436V684A252.5 201.5 0 0 1 941 684V1687Z"/><path fill="#B8945C" d="M465 1658A223.5 223 0 0 1 912 1658Z"/></svg>';

  const fromCard = (card) => {
    /* the product page carries its details as data attributes (snippets/nuvo-pdp-actions.liquid) */
    if (card.dataset.nfTitle) {
      const d = card.dataset;
      return { id: String(d.productId), title: d.nfTitle, url: d.nfUrl || '', img: d.nfImg || '', price: d.nfPrice || '' };
    }
    const img = card.querySelector('.item-image img, .nhs-card__img img');
    const priceText = ((card.querySelector('.item-price .price, .nhs-card__price') || {}).textContent || '').replace(/\s+/g, ' ').trim();
    return {
      id: String(card.dataset.productId),
      title: ((card.querySelector('.item-title, .nhs-card__title') || {}).textContent || '').split(' | ')[0].trim(),
      url: (card.querySelector('a.item-link, a.nhs-card__link') || {}).getAttribute?.('href') || '',
      img: img ? (img.currentSrc || img.src) : '',
      price: priceText,
    };
  };

  /* ---------- header button ---------- */
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'nfv-btn';
  btn.innerHTML = HEART + '<span class="nfv-btn__n" aria-hidden="true"></span>';
  const mountBtn = () => {
    const cart = document.getElementById('cart-icon-bubble');
    if (cart && btn.nextSibling !== cart) cart.before(btn);
  };

  /* ---------- panel ---------- */
  const sheet = document.createElement('div');
  sheet.className = 'nfv';
  sheet.setAttribute('role', 'dialog');
  sheet.setAttribute('aria-modal', 'true');
  sheet.setAttribute('aria-label', 'Your favorites');
  sheet.innerHTML = '<div class="nfv__scrim"></div><aside class="nfv__panel"><div class="nfv__head"><p class="nfv__title">Your favorites<sup></sup></p>' +
    '<button type="button" class="nfv__close" aria-label="Close">' +
    '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15"/></svg></button></div><div class="nfv__list"></div><div class="nfv__foot"></div></aside>';
  const list = sheet.querySelector('.nfv__list');
  const foot = sheet.querySelector('.nfv__foot');
  const MAX = 4;
  let chosen = null;

  const renderList = () => {
    const favs = read();
    /* compare picks: the first few favorites unless the shopper changed them */
    if (!chosen) chosen = new Set(favs.slice(0, MAX).map((f) => f.id));
    chosen.forEach((id) => { if (!favs.some((f) => f.id === id)) chosen.delete(id); });
    sheet.querySelector('.nfv__title sup').textContent = favs.length ? String(favs.length) : '';
    list.innerHTML = favs.length ? favs.map((f) =>
      `<div class="nfv-item" data-id="${esc(f.id)}"><a class="nfv-item__img" href="${esc(f.url)}">${f.img ? `<img src="${esc(f.img)}" alt="" loading="lazy">` : ''}</a>` +
      `<div class="nfv-item__body"><a class="nfv-item__title" href="${esc(f.url)}">${esc(f.title)}</a><span class="nfv-item__price">${esc(f.price)}</span>` +
      `<a class="nfv-item__view" href="${esc(f.url)}">View piece</a>` +
      (favs.length > 1 ? `<button type="button" class="nfv-item__cmp${chosen.has(f.id) ? ' is-on' : ''}" aria-pressed="${chosen.has(f.id)}"><i></i>Compare</button>` : '') + '</div>' +
      `<button type="button" class="nfv-item__remove" aria-label="Remove ${esc(f.title)} from favorites">${HEART}</button></div>`).join('')
      : `<div class="nfv-empty">${ARCH}<p class="nfv-empty__title">No favorites yet</p><p class="nfv-empty__sub">Tap the heart on any piece to keep it here.</p>` +
        '<a class="nfv-empty__cta" href="/collections/best-sellers">Shop Best Sellers</a></div>';
    const n = chosen.size;
    foot.innerHTML = favs.length > 1
      ? `<p>${n < 2 ? 'Pick two to four pieces to compare.' : `${n} pieces selected`}</p><button type="button" class="nfv__compare"${n < 2 ? ' disabled' : ''}>Compare side by side</button>`
      : '';
  };

  /* ---------- compare ---------- */
  const handleOf = (url) => (String(url).match(/\/products\/([^/?#]+)/) || [])[1];
  const money = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD', maximumFractionDigits: 0 }).format(cents / 100);
  const MATERIALS = ['Powder Coat', 'Stainless Steel', 'Corten Steel', 'Hammered Copper', 'GFRC Concrete', 'GFRC Woodgrain'];
  const optionValues = (p, re) => {
    const o = p.options.find((x) => re.test(x.name));
    return o ? o.values.join(', ') : '';
  };
  const ROWS = [
    ['Category', (p) => p.type],
    ['Starting at', (p) => money(p.price_min), 'is-price'],
    ['Material', (p) => p.tags.filter((t) => MATERIALS.includes(t)).join(', ')],
    ['Sizes', (p) => optionValues(p, /size/i)],
    ['Ignition', (p) => optionValues(p, /ignition/i)],
    ['Finishes', (p) => optionValues(p, /color|finish/i)],
    ['Gas', (p) => optionValues(p, /gas|fuel/i) || (p.tags.includes('Gas Selectable') ? 'Natural gas or liquid propane' : '')],
    ['Made in', (p) => (p.tags.includes('USA Made') ? 'USA, made to order' : '')],
  ];
  const cmp = document.createElement('div');
  cmp.className = 'nfc';
  cmp.setAttribute('role', 'dialog');
  cmp.setAttribute('aria-modal', 'true');
  cmp.setAttribute('aria-label', 'Compare favorites');
  const openCompare = async () => {
    const picks = read().filter((f) => chosen.has(f.id)).slice(0, MAX);
    cmp.innerHTML = '<div class="nfc__head"><p class="nfc__title">Compare your favorites</p><button type="button" class="nfv__close" aria-label="Close">' +
      '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15"/></svg></button></div><div class="nfc__body"><p class="nfc__loading">Loading…</p></div>';
    document.body.appendChild(cmp);
    requestAnimationFrame(() => cmp.classList.add('is-open'));
    const data = await Promise.all(picks.map((f) => fetch(`/products/${handleOf(f.url)}.js`, { headers: { Accept: 'application/json' } })
      .then((r) => r.json()).catch(() => null)));
    const cols = picks.map((f, i) => ({ f, p: data[i] }));
    let html = '<table><thead><tr><th></th>' + cols.map(({ f }) =>
      `<th class="nfc__card">${f.img ? `<img src="${esc(f.img)}" alt="">` : ''}<b>${esc(f.title)}</b><a href="${esc(f.url)}">View piece</a></th>`).join('') + '</tr></thead><tbody>';
    ROWS.forEach(([label, get, cls]) => {
      html += `<tr><th>${label}</th>` + cols.map(({ p }) => {
        const v = p ? get(p) : '';
        return `<td${cls ? ` class="${cls}"` : ''}>${v ? esc(v) : '<span class="nfc__muted">—</span>'}</td>`;
      }).join('') + '</tr>';
    });
    cmp.querySelector('.nfc__body').innerHTML = html + '</tbody></table>';
  };
  const closeCompare = () => { cmp.classList.remove('is-open'); setTimeout(() => cmp.remove(), 300); };
  cmp.addEventListener('click', (e) => { if (e.target.closest('.nfv__close')) closeCompare(); });

  const sync = () => {
    const n = read().length;
    btn.querySelector('.nfv-btn__n').textContent = n ? String(n) : '';
    btn.setAttribute('aria-label', n ? `Favorites, ${n} saved` : 'Favorites');
    document.querySelectorAll('.nf-heart').forEach((h) => paint(h, has(h.closest('.grid-item, [data-nf-card]')?.dataset.productId)));
    if (sheet.classList.contains('is-open')) renderList();
  };

  let lastFocus = null;
  const open = () => {
    renderList();
    lastFocus = document.activeElement;
    if (!sheet.isConnected) document.body.appendChild(sheet);
    requestAnimationFrame(() => sheet.classList.add('is-open'));
    document.documentElement.classList.add('nfv-lock');
    setTimeout(() => sheet.querySelector('.nfv__close').focus({ preventScroll: true }), 50);
  };
  const close = () => {
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('nfv-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };
  btn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); open(); });
  sheet.addEventListener('click', (e) => {
    if (e.target.closest('.nfv__close') || e.target.classList.contains('nfv__scrim')) { close(); return; }
    const rm = e.target.closest('.nfv-item__remove');
    if (rm) { write(read().filter((f) => f.id !== rm.closest('.nfv-item').dataset.id)); sync(); return; }
    const pick = e.target.closest('.nfv-item__cmp');
    if (pick) {
      const id = pick.closest('.nfv-item').dataset.id;
      if (chosen.has(id)) chosen.delete(id); else if (chosen.size < MAX) chosen.add(id);
      renderList();
      return;
    }
    if (e.target.closest('.nfv__compare')) openCompare();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (cmp.isConnected) closeCompare(); else if (sheet.classList.contains('is-open')) close();
  });

  /* ---------- hearts on cards (collection pages) ---------- */
  const paint = (h, on) => {
    h.classList.toggle('is-on', !!on);
    h.setAttribute('aria-pressed', on ? 'true' : 'false');
    h.setAttribute('aria-label', on ? 'Remove from favorites' : 'Add to favorites');
  };
  const onCollection = /^collection/.test(document.body.className);
  const addHeart = (card) => {
    if (!card.dataset.productId || card.querySelector('.nf-heart')) return;
    /* list cards keep price and actions in a column of their own; grid cards inside the details */
    const slot = card.querySelector('.item-link > .item-actions-wrapper') || card.querySelector('.item-actions-wrapper');
    if (!slot) return;
    const h = document.createElement('button');
    h.type = 'button';
    h.className = 'nf-heart';
    h.innerHTML = HEART;
    paint(h, has(card.dataset.productId));
    slot.prepend(h);
  };
  /* the heart sits inside the card's link: keep the click from opening the product */
  document.addEventListener('click', (e) => {
    const h = e.target.closest && e.target.closest('.nf-heart');
    if (!h) return;
    e.preventDefault();
    e.stopPropagation();
    const card = h.closest('.grid-item, [data-nf-card]');
    if (!card) return;
    const item = fromCard(card);
    const favs = read();
    const on = !favs.some((f) => f.id === item.id);
    write(on ? [item, ...favs] : favs.filter((f) => f.id !== item.id));
    paint(h, on);
    sync();
    if (on) {
      [h, btn].forEach((el) => { el.classList.remove('nf-pop'); void el.offsetWidth; el.classList.add('nf-pop'); });
      const price = parseFloat(item.price.replace(/[^\d.]/g, '')) || undefined;
      try { window.Shopify && Shopify.analytics && Shopify.analytics.publish('nuvo_favorite_added', { product_id: item.id, title: item.title, url: location.origin + item.url, price, currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }); } catch (err) {}
    }
  }, true);

  const run = () => {
    mountBtn();
    sync();
    if (!onCollection) return;
    const scan = (root) => root.querySelectorAll('.grid-item[data-product-id]').forEach(addHeart);
    scan(document);
    const grid = document.getElementById('CollectionProducts');
    if (grid) new MutationObserver(() => scan(grid)).observe(grid, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();

  /* the theme redraws the header cart after every cart change; keep the heart beside it */
  const watch = () => { const w = document.querySelector('.header__buttons--wrapper'); if (w) new MutationObserver(mountBtn).observe(w, { childList: true }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();

  /* another tab changed the list */
  addEventListener('storage', (e) => { if (e.key === KEY) sync(); });
})();
